import React, { useEffect, useState } from 'react';
import {
  Box,
  GDSStyleObject,
  Radio,
  Fieldset,
  StatusBanner,
  UtilityText,
} from '@leagueplatform/genesis-core';
import COBQuestioner from '../../../assets/json/COB_QUESTIONER.json';
import useCobStore from '../../../store/cob-store';
import { COBLayout } from '../../cob-layout/cob-layout';
import { isEmpty, isNotEmpty } from '../../helpers/helpers';
import '../forms.css';

export function OtherInsurance(props: any) {
  // eslint-disable-next-line react/prop-types
  const { errorHandling, nextButtonClicked, nextDisabled, noNext } = props;
  const updateCobInformation = useCobStore(
    (state: any) => state.updateCobInformation,
  );
  // const fetchCobInformations = useCobStore((state:any) => state.fetchCobInformations );
  const cobResponse = useCobStore((state: any) => state.cobInformation);
  const dependantList = useCobStore((state: any) => state.demographics);
  const initialCOB = useCobStore((state: any) => state.initialCOB);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hasAdditionalInsurance, setHasAdditionalInsurance] = useState('');
  // const [errors, setErrors] = useState<boolean>(false);
  const [errors, setErrors] = useState({ hasAdditionalInsurance: '' });

  useEffect(() => {
    noNext(false);
    if (
      hasAdditionalInsurance !== '' ||
      cobResponse?.additionalInsurance[0]?.hasAdditionalInsurance !== ''
    ) {
      errorHandling(true);
      nextDisabled(false);
      noNext(false);
    } else {
      nextDisabled(true);
    }
  }, [
    nextDisabled,
    hasAdditionalInsurance,
    cobResponse,
    errorHandling,
    noNext,
  ]);

  const findHasAdditionalInsurance = () => {
    const getFilteredInfo = cobResponse?.additionalInsurance
      ?.filter(
        (item: any) =>
          item.member.firstName === dependantList?.demographics?.firstName,
      )
      .map((item: any) => item);
    return getFilteredInfo?.length !== 0
      ? getFilteredInfo[0]
      : initialCOB.additionalInsurance[0];
  };

  const [form, setForm] = useState({
    hasAdditionalInsurance:
      findHasAdditionalInsurance() !== undefined
        ? findHasAdditionalInsurance().hasAdditionalInsurance
        : '',
  });

  const formField = isEmpty(form.hasAdditionalInsurance);

  const isValid = isNotEmpty(form.hasAdditionalInsurance);

  useEffect(() => {
    if (formField) {
      if (!isValid) {
        setErrors({
          hasAdditionalInsurance: isEmpty(form.hasAdditionalInsurance)
            ? 'error'
            : '',
        });
      }
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [errorHandling, formField, form, errors.hasAdditionalInsurance, isValid]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        setErrors({
          hasAdditionalInsurance: isEmpty(
            form.hasAdditionalInsurance,
          ).toString(),
        });
      }
    }
  }, [nextButtonClicked, isValid, form]);

  const updateHandler = (event: any) => {
    const getFilteredDetail = findHasAdditionalInsurance();

    if (getFilteredDetail !== undefined) {
      getFilteredDetail.hasAdditionalInsurance = event.target.value;
      getFilteredDetail.member.firstName =
        dependantList?.demographics?.firstName;
      getFilteredDetail.member.lastName = dependantList?.demographics?.lastName;
      getFilteredDetail.member.suffix = '';
      // getFilteredDetail.member.gender = dependantList[0].demographics.gender;
      getFilteredDetail.member.dateOfBirth =
        dependantList.demographics?.dateOfBirth;
      getFilteredDetail.hasAdditionalInsurance = event.target.value;
      // updateCobInformation(getFilteredDetail);
    } else {
      if (cobResponse.additionalInsurance.length > 0) {
        cobResponse.additionalInsurance[0].member.firstName =
          dependantList.demographics.firstName;
        cobResponse.additionalInsurance[0].member.lastName =
          dependantList.demographics.lastName;
        cobResponse.additionalInsurance[0].member.dateOfBirth =
          dependantList.demographics.dateOfBirth;
        cobResponse.additionalInsurance[0].hasAdditionalInsurance =
          event.target.value;
      }
      form.hasAdditionalInsurance = event.target.value;
      // updateCobInformation(cobResponse);
    }
    setHasAdditionalInsurance(event.target.value);
    updateCobInformation(cobResponse);
    setForm({ hasAdditionalInsurance: event.target.value });
    setErrors({ hasAdditionalInsurance: '' });
    // errorHandling(true);
  };

  return (
    <COBLayout
      title={COBQuestioner.COB.INFORMATION.INSURANCEINFO}
      questionTitle={COBQuestioner.COB.QUESTIONS.OTHERQUESTION}
      disclaimer={COBQuestioner.COB.QUESTIONS.QUESTIONSDISCLAIMER}
      dataTestId="OtherInsuranceSection"
      isDependant={false}
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
          } as GDSStyleObject
        }
      >
        <Fieldset
          legend=""
          aria-labelledby="hasOtherInsuranceTitle"
          id="hasOtherInsurance"
          css={
            { marginTop: '$half', borderRadius: '$medium' } as GDSStyleObject
          }
          inputStatus={
            errors.hasAdditionalInsurance === 'error' ? 'error' : undefined
          }
        >
          <Box className="GDS-radio-warapper marginBottom15">
            <Radio
              id="other-insurance-1"
              name="hasAdditionalInsurance"
              value={COBQuestioner.COB.UTILS.VALUE.YES ? 'Y' : ''}
              label={COBQuestioner.COB.UTILS.YES}
              style={{ color: 'blue' }}
              layout="row"
              onChange={(e) => {
                updateHandler(e);
              }}
              checked={
                findHasAdditionalInsurance()?.hasAdditionalInsurance ===
                COBQuestioner.COB.UTILS.VALUE.YES
              }
              data-testid="othIns-yes"
            />
          </Box>
          <Box className="GDS-radio-warapper">
            <Radio
              id="other-insurance-2"
              name="hasAdditionalInsurance"
              value={COBQuestioner.COB.UTILS.VALUE.NO ? 'N' : ''}
              label={COBQuestioner.COB.UTILS.NO}
              layout="row"
              onChange={(e) => {
                updateHandler(e);
              }}
              checked={
                findHasAdditionalInsurance()?.hasAdditionalInsurance ===
                COBQuestioner.COB.UTILS.VALUE.NO
              }
              data-testid="othIns-no"
            />
          </Box>
        </Fieldset>
      </Box>
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '$one $none $none $none',
            '@media screen and (max-width: 390px)': {
              width: '92vw !important',
            },
            '@mobile': {
              width: '85vw',
            },
            '@desktop': {
              maxWidth: '368px',
            },
          } as GDSStyleObject
        }
      >
        <StatusBanner
          status="brand"
          icon="interfaceQuestionCircleFilled"
          title={COBQuestioner.COB.INFORMATION.YOUSHOULDKNOW}
          css={
            {
              typography: '$subtitleTwo',
              lineHeight: '16px',
              fontSize: '$label',
              marginTop: '$three',
              letterSpacing: '$overline',
              p: {
                fontSize: '$label',
              },
            } as GDSStyleObject
          }
        >
          <UtilityText
            css={
              {
                fontSize: '$label',
                paddingLeft: '5px',
                marginLeft: '-32px',
                marginRight: '8px',
                lineHeight: '16px',
                marginTop: '$one',
              } as GDSStyleObject
            }
          >
            {COBQuestioner.COB.INFORMATION.SHOULDKNOWINFO}
          </UtilityText>
        </StatusBanner>
      </Box>
    </COBLayout>
  );
}
